import { createTheme } from "@mui/material/styles";

export const tokens = {
  bone: "#FAF7F1",
  paper: "#FFFFFF",
  ink: "#1B1A17",
  taupe: "#6F695E",
  line: "#E7E1D6",
  accent: "#2F5651",
  accentSoft: "#3C6A64",
  brass: "#B79256",
  display: '"Cormorant Garamond", Georgia, serif',
  sans: '"Manrope", system-ui, sans-serif',
} as const;

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: tokens.accent, contrastText: "#FBF9F4" },
    secondary: { main: tokens.brass },
    background: { default: tokens.bone, paper: tokens.paper },
    text: { primary: tokens.ink, secondary: tokens.taupe },
    divider: tokens.line,
  },
  shape: { borderRadius: 2 },
  typography: {
    fontFamily: tokens.sans,
    h1: { fontFamily: tokens.display, fontWeight: 500, letterSpacing: "-0.01em", lineHeight: 1.02 },
    h2: { fontFamily: tokens.display, fontWeight: 500, letterSpacing: "-0.01em", lineHeight: 1.08 },
    h3: { fontFamily: tokens.display, fontWeight: 500, lineHeight: 1.12 },
    h4: { fontFamily: tokens.display, fontWeight: 500, lineHeight: 1.18 },
    h5: { fontFamily: tokens.display, fontWeight: 500 },
    h6: { fontFamily: tokens.display, fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    body1: { fontSize: "1.02rem", lineHeight: 1.7, color: tokens.taupe },
    body2: { lineHeight: 1.65, color: tokens.taupe },
    button: { textTransform: "none", fontWeight: 600, letterSpacing: "0.02em" },
    overline: {
      fontSize: "0.72rem",
      fontWeight: 600,
      letterSpacing: "0.22em",
      textTransform: "uppercase",
      color: tokens.taupe,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: { body: { backgroundColor: tokens.bone } },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 1, paddingInline: 22, paddingBlock: 10 },
        outlined: { borderColor: tokens.ink, color: tokens.ink, "&:hover": { borderColor: tokens.ink, backgroundColor: "rgba(27,26,23,0.04)" } },
        containedPrimary: { backgroundColor: tokens.ink, "&:hover": { backgroundColor: "#000" } },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
        outlined: { borderColor: tokens.line },
      },
    },
    MuiAppBar: {
      styleOverrides: { root: { boxShadow: "none" } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 4 } },
    },
    MuiTextField: { defaultProps: { variant: "outlined", size: "small" } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { backgroundColor: tokens.paper, borderRadius: 2 },
        notchedOutline: { borderColor: tokens.line },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: { textTransform: "uppercase", letterSpacing: "0.16em", fontSize: "0.74rem", fontWeight: 600 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 1, fontWeight: 600, letterSpacing: "0.04em" },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { backgroundColor: tokens.ink, fontSize: "0.72rem", letterSpacing: "0.04em" },
      },
    },
  },
});

export default theme;
